import API from "../constants/api.constant";
import { responseErrorHandling } from "../helper/common.helper";
import axiosInstance from "./axiosInstance";

export const createCoOwner = async (payload: Object) => {
  try {
    const response = await axiosInstance.post(
      API.CREATE_CO_OWNER_PROFILE,
      payload
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const getCoOwners = async (payload: Object) => {
  try {
    const response = await axiosInstance.get(API.GET_ALL_CO_OWNERS, {
      params: payload,
    });
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const deleteCoOwnerById = async (id: string) => {
  try {
    const response = await axiosInstance.delete(API.DELETE_CO_OWNER + id);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

export const updateCoOwner = async (id:string, payload: object) => {
    try {
    const response = await axiosInstance.patch(API.UPDATE_CO_OWNER + id, payload);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

export const blockCoOwner = async (id:string, payload: object) => {
    try {
    const response = await axiosInstance.patch(API.BLOCK_CO_OWNER + id, payload);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

// change CoOwner password
export const changeCoOwnerPassword = async ( id: string, data: object) => {
 try {
  const response = await axiosInstance.put(API.CO_OWNER_PASSWORD_CHANGE + id, data);
  return response.data;
 } catch (error:any) {
  responseErrorHandling(error)
 }
}

// get coOwner profile
export const getCoOwnerProfile = async ( id: string) => {
 try {
  const response = await axiosInstance.get(API.GET_CO_OWNER_PROFILE + id);
  return response.data;
 } catch (error:any) {
  responseErrorHandling(error)
 }
}

// update coOwner profile
export const updateCoOwnerProfile = async ( id: string, data: object) => {
 try {
  const response = await axiosInstance.patch(API.UPDATE_CO_OWNER + id, data);
  return response.data;
 } catch (error:any) {
  responseErrorHandling(error)
 }
}